import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './http-interceptors/auth-interceptor';
import { CustomHammerConfig } from './utils/custom-hammer-config';
import { FormsModule } from '@angular/forms';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { ClipboardModule } from 'ngx-clipboard';
import {
    APP_BASE_HREF,
    CommonModule,
    Location,
    LocationStrategy,
    NgOptimizedImage,
    PathLocationStrategy
} from '@angular/common';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection(),
        importProvidersFrom([
            BrowserAnimationsModule,
            BrowserModule,
            FormsModule,
            LazyLoadImageModule,
            ClipboardModule,
            HammerModule,
            CommonModule,
            NgOptimizedImage
        ]),
        provideHttpClient(withInterceptorsFromDi()),
        Location,
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        { provide: APP_BASE_HREF, useValue: '/' },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: CustomHammerConfig
        },
        { provide: 'environment_config', useValue: environment }
    ]
};
